export enum AuthMode {
  login = 'login',
  verify = 'verify',
  reset = 'reset'
}
